import { render, staticRenderFns } from "./VDesigningPlansForm.vue?vue&type=template&id=310b496c&"
import script from "./VDesigningPlansForm.vue?vue&type=script&lang=ts&"
export * from "./VDesigningPlansForm.vue?vue&type=script&lang=ts&"
import style0 from "./VDesigningPlansForm.vue?vue&type=style&index=0&id=310b496c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports